import React from 'react';
import { Tabs } from 'flowbite-react';
import Image from 'next/image';
import MWSVG from '../common/svg';

const AiStrategyTechStack = () => {
    return (
        <div className="section-py bg-grey dark:bg-black overflow-x-hidden border-b"
        style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-11">
                    <div className="lg:col-span-12 text-center">
                        <h2 className="dark:text-white">Tech Stack</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 technologies-tools-tab overflow-x-hidden">
                    <div className="lg:col-span-12 grid">
                        <Tabs.Group className="items-center	tab-items" aria-label="underline tabs" style="underline">
                            <Tabs.Item active title="Assessment & Analytics">
                                <div className="row grid xl:grid-cols-6 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-CMMI-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="CMMI-AI"
                                            title="CMMI-AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">CMMI-AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-PAIR.svg"
                                            className="img-fluid mb-2.5"
                                            alt="CMMI-AI"
                                            title="CMMI-AI"
                                            height={50}
                                            width={50}
                                        />                                       
                                        <p className="text-base font-semibold mb-0 dark:text-white">Google PAIR</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Microsoft-AI-Maturity.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Microsoft AI Maturity"
                                            title="Microsoft AI Maturity"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Microsoft AI Maturity</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Gartner-frameworks.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Gartner frameworks"
                                            title="Gartner frameworks"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Gartner frameworks</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-McKinsey.svg"
                                            className="img-fluid mb-2.5"
                                            alt="McKinsey frameworks"
                                            title="McKinsey frameworks"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">McKinsey frameworks</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Custom-Scorecards.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Custom Scorecards"
                                            title="Custom Scorecards"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Custom Scorecards</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="ROI & Financial Modeling">
                                <div className="row grid xl:grid-cols-6 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-excel.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Excel"
                                            title="Excel"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Excel</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-sheet.svg"
                                            className="img-fluid mb-2.5 !h-10"
                                            alt="Google Sheets"
                                            title="Google Sheets"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Google Sheets</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Tableau.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Tableau"
                                            title="Tableau"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Tableau</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/icons/pbI-logo.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Power BI"
                                            title="Power BI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Power BI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Monte-Carlo.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Monte Carlo simulations"
                                            title="Monte Carlo simulations"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Monte Carlo simulations</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/IRR-Calculators.svg"
                                            className="img-fluid mb-2.5"
                                            alt="NPV/IRR calculators"
                                            title="NPV/IRR calculators"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">NPV/IRR Calculators</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Collaboration Tools">
                                <div className="row grid xl:grid-cols-7 lg:grid-cols-4 md:grid-cols-4 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Miro.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Miro"
                                            title="Miro"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Miro</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Mural.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Mural"
                                            title="Mural"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Mural</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Figma.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Figma"
                                            title="Figma"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Figma</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Notion.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Notion"
                                            title="Notion"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Notion</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Confluence.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Confluence"
                                            title="Confluence"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Confluence</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Slack.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Slack"
                                            title="Slack"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Slack</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Microsoft-Teams.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Microsoft Teams"
                                            title="Microsoft Teams"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Microsoft Teams</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Proof-of-Concept">
                                <div className="row grid xl:grid-cols-6 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Jupyter.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Jupyter"
                                            title="Jupyter"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Jupyter</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Streamlit.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Streamlit"
                                            title="Streamlit"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Streamlit</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-Gradio.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Gradio"
                                            title="Gradio"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Gradio</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="img-aws" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="text-base font-semibold mb-0 dark:text-white">AWS Sandbox</p>
                                    </div>
                                     <div className="tech-box">
                                        <Image
                                           src="/img/technologies-icon/img-azure.svg"
                                           className="img-fluid mb-2.5"
                                           alt="Azure Sandbox"
                                           title="Azure Sandbox"
                                           height={50}
                                           width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure Sandbox</p>
                                    </div>
                                     <div className="tech-box">
                                        <Image
                                            src="/img/ai-strategy/ic-GCP-Sandbox.svg"
                                            className="img-fluid mb-2.5"
                                            alt="GCP Sandbox"
                                            title="GCP Sandbox"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">GCP Sandbox</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                        </Tabs.Group>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AiStrategyTechStack;
